import { freshModal } from "../freshModal";
import React, { useState } from "react";
import Modal from "./Modal";

const AddPayslipModalFormSession = ({ isOpen, onClose, onSave, candidateId }) => {
  const [formData, setFormData] = useState({
    period: "",
    amount: "",
    hoursWorked: "",
    isPaid: false,
    notes: "",
    fileUpload: null,
    candidateId,
  });

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "checkbox") {
      const target = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: target.checked,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFormData((prevData) => ({
        ...prevData,
        fileUpload: e.target.files[0],
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Ajouter un bulletin de paie"
      className="max-w-xl"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label
            htmlFor="period"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Période
          </label>
          <input
            type="month"
            id="period"
            name="period"
            required
            value={formData.period}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              htmlFor="amount"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Montant net (€)
            </label>
            <input
              type="number"
              id="amount"
              name="amount"
              required
              step="0.01"
              value={formData.amount}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label
              htmlFor="hoursWorked"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Heures travaillées
            </label>
            <input
              type="number"
              id="hoursWorked"
              name="hoursWorked"
              required
              step="0.01"
              value={formData.hoursWorked}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="isPaid"
            name="isPaid"
            checked={formData.isPaid}
            onChange={handleChange}
            className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500 border-gray-300"
          />
          <label htmlFor="isPaid" className="ml-2 block text-sm text-gray-700">
            Déjà payé
          </label>
        </div>

        <div>
          <label
            htmlFor="fileUpload"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Joindre le bulletin (PDF)
          </label>
          <input
            type="file"
            id="fileUpload"
            name="fileUpload"
            accept=".pdf"
            onChange={handleFileChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div>
          <label
            htmlFor="notes"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Notes complémentaires
          </label>
          <textarea
            id="notes"
            name="notes"
            rows={2}
            value={formData.notes}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Annuler
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Enregistrer
          </button>
        </div>
      </form>
    </Modal>
  );
};

export const AddPayslipModal = freshModal(AddPayslipModalFormSession, "isOpen");
